export function capitalizeFirst(value: string): string {
  if (value.length === 0) {
    return value;
  }
  return value.charAt(0).toLocaleUpperCase() + value.slice(1);
}
